var _excluded = ["content", "image", "gutter", "hasImageStickyToRightOnSmall", "hasImageStickyToBottom", "isStickyToTop", "isReversedOnLarge", "isReversedOnMobile", "isImageHiddenOnSmall", "isImageHiddenOnMedium", "hasImageUnderContent"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React, { useContext } from "react";
import styled, { css } from "styled-components";
import SectionSpacingValueSpaceContext from "../../../contexts/SectionSpacingValueSpaceContext";
import { pageGutterSpace } from "../../../settings";
import breakpoint from "../../../utils/breakpoint";
import space from "../../../utils/space";
var defaultProps = {
  gutter: "medium"
};
var gutters = {
  small: 5,
  medium: 10,
  big: 20
};
var Container = styled.div.withConfig({
  componentId: "sc-1ryctnb-0"
})(function (_ref) {
  var $gutter = _ref.$gutter,
    $hasImageUnderContent = _ref.$hasImageUnderContent,
    $isStickyToTop = _ref.$isStickyToTop;
  return css(["display:grid;grid-gap:", ";", " ", ""], space(gutters[$gutter] / 2), !$hasImageUnderContent ? css(["", "{grid-gap:", ";grid-template-columns:1fr 1fr;align-items:", ";}"], breakpoint("large"), space(gutters[$gutter]), $isStickyToTop ? "flex-start" : "center") : null, $isStickyToTop ? css(["align-items:flex-start;"]) : null);
});
var Image = styled.div.withConfig({
  componentId: "sc-1ryctnb-1"
})(function (_ref2) {
  var $hasImageStickyToBottom = _ref2.$hasImageStickyToBottom,
    $hasImageStickyToRightOnSmall = _ref2.$hasImageStickyToRightOnSmall,
    $isReversedOnLarge = _ref2.$isReversedOnLarge,
    $isReversedOnMobile = _ref2.$isReversedOnMobile,
    $sectionBottomSpacingValueSpace = _ref2.$sectionBottomSpacingValueSpace,
    $isImageHiddenOnSmall = _ref2.$isImageHiddenOnSmall,
    $isImageHiddenOnMedium = _ref2.$isImageHiddenOnMedium;
  return css(["justify-self:center;", " ", " ", " ", " ", " ", ""], $hasImageStickyToRightOnSmall && css(["", "{justify-self:flex-end;margin-right:", ";}"], breakpoint("small", "medium"), space(-1 * pageGutterSpace)), $isImageHiddenOnSmall && css(["", "{display:none;}"], breakpoint("small", "medium")), $isImageHiddenOnMedium && css(["", "{display:none;}"], breakpoint("medium", "large")), $hasImageStickyToBottom && $sectionBottomSpacingValueSpace && css(["align-self:flex-end;margin-bottom:", ";"], space(-1 * $sectionBottomSpacingValueSpace)), $isReversedOnLarge && css(["", "{order:-1;}"], breakpoint("large")), $isReversedOnMobile && css(["", "{order:-1;}"], breakpoint("small", "large")));
});
function ContentWithImageOrg(_ref3) {
  var content = _ref3.content,
    image = _ref3.image,
    _ref3$gutter = _ref3.gutter,
    gutter = _ref3$gutter === void 0 ? defaultProps.gutter : _ref3$gutter,
    hasImageStickyToRightOnSmall = _ref3.hasImageStickyToRightOnSmall,
    hasImageStickyToBottom = _ref3.hasImageStickyToBottom,
    isStickyToTop = _ref3.isStickyToTop,
    isReversedOnLarge = _ref3.isReversedOnLarge,
    isReversedOnMobile = _ref3.isReversedOnMobile,
    isImageHiddenOnSmall = _ref3.isImageHiddenOnSmall,
    isImageHiddenOnMedium = _ref3.isImageHiddenOnMedium,
    hasImageUnderContent = _ref3.hasImageUnderContent,
    restProps = _objectWithoutProperties(_ref3, _excluded);
  var sectionBottomSpacingValueSpace = useContext(SectionSpacingValueSpaceContext).bottom;
  return /*#__PURE__*/React.createElement(Container, _extends({
    $gutter: gutter,
    $hasImageUnderContent: hasImageUnderContent,
    $isStickyToTop: !!isStickyToTop
  }, restProps), /*#__PURE__*/React.createElement("div", null, content), /*#__PURE__*/React.createElement(Image, {
    $hasImageStickyToRightOnSmall: !!hasImageStickyToRightOnSmall,
    $hasImageStickyToBottom: !!hasImageStickyToBottom,
    $isReversedOnLarge: !!isReversedOnLarge,
    $isReversedOnMobile: !!isReversedOnMobile,
    $isImageHiddenOnSmall: !!isImageHiddenOnSmall,
    $isImageHiddenOnMedium: !!isImageHiddenOnMedium,
    $sectionBottomSpacingValueSpace: sectionBottomSpacingValueSpace
  }, image));
}
export default ContentWithImageOrg;